'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _auth = require('../actions/auth');

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

require('../styles/GoogleLoginButton.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Login = function (_React$Component) {
    _inherits(Login, _React$Component);

    function Login(props) {
        _classCallCheck(this, Login);

        var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

        _this.onRequestLogin = _this.onRequestLogin.bind(_this);
        return _this;
    }

    _createClass(Login, [{
        key: 'onRequestLogin',
        value: function onRequestLogin() {
            this.props.loginRequest();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                errorMessage = _props.errorMessage,
                requestingLogin = _props.requestingLogin;


            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h1',
                    { style: { textAlign: 'center' } },
                    'Apps de Bolso - Conte\xFAdo'
                ),
                _react2.default.createElement('div', { className: 'login-button', onClick: this.onRequestLogin }),
                errorMessage && errorMessage.length > 1 && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        { style: { textAlign: 'center', color: 'red' } },
                        errorMessage
                    )
                ),
                requestingLogin && _react2.default.createElement(
                    'div',
                    { style: { textAlign: 'center' } },
                    _react2.default.createElement(_CircularProgress2.default, { size: 60 })
                )
            );
        }
    }]);

    return Login;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        requestingLogin: state.auth.requestingLogin,
        errorMessage: state.auth.loginErrorMessage
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)(_auth.actionCreators, dispatch);
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Login));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29udGFpbmVycy9Mb2dpbi5qcyJdLCJuYW1lcyI6WyJMb2dpbiIsInByb3BzIiwib25SZXF1ZXN0TG9naW4iLCJiaW5kIiwibG9naW5SZXF1ZXN0IiwiZXJyb3JNZXNzYWdlIiwicmVxdWVzdGluZ0xvZ2luIiwidGV4dEFsaWduIiwibGVuZ3RoIiwiY29sb3IiLCJSZWFjdCIsIkNvbXBvbmVudCIsIm1hcFN0YXRlVG9Qcm9wcyIsInN0YXRlIiwiYXV0aCIsImxvZ2luRXJyb3JNZXNzYWdlIiwibWFwRGlzcGF0Y2hUb1Byb3BzIiwiZGlzcGF0Y2giLCJhY3Rpb25DcmVhdG9ycyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7Ozs7QUFDQTs7Ozs7Ozs7OztJQUVNQSxLOzs7QUFFRixtQkFBWUMsS0FBWixFQUFtQjtBQUFBOztBQUFBLGtIQUNUQSxLQURTOztBQUdmLGNBQUtDLGNBQUwsR0FBc0IsTUFBS0EsY0FBTCxDQUFvQkMsSUFBcEIsT0FBdEI7QUFIZTtBQUlsQjs7Ozt5Q0FFZ0I7QUFDYixpQkFBS0YsS0FBTCxDQUFXRyxZQUFYO0FBQ0g7OztpQ0FFUTtBQUFBLHlCQUNxQyxLQUFLSCxLQUQxQztBQUFBLGdCQUNHSSxZQURILFVBQ0dBLFlBREg7QUFBQSxnQkFDaUJDLGVBRGpCLFVBQ2lCQSxlQURqQjs7O0FBR0wsbUJBQ0k7QUFBQTtBQUFBO0FBQ0k7QUFBQTtBQUFBLHNCQUFJLE9BQU8sRUFBQ0MsV0FBVyxRQUFaLEVBQVg7QUFBQTtBQUFBLGlCQURKO0FBRUksdURBQUssV0FBVSxjQUFmLEVBQThCLFNBQVMsS0FBS0wsY0FBNUMsR0FGSjtBQUlRRyxnQ0FBZ0JBLGFBQWFHLE1BQWIsR0FBc0IsQ0FBdEMsSUFDQTtBQUFBO0FBQUE7QUFBSztBQUFBO0FBQUEsMEJBQUcsT0FBTyxFQUFDRCxXQUFXLFFBQVosRUFBc0JFLE9BQU8sS0FBN0IsRUFBVjtBQUFpREo7QUFBakQ7QUFBTCxpQkFMUjtBQVFRQyxtQ0FDQTtBQUFBO0FBQUEsc0JBQUssT0FBTyxFQUFDQyxXQUFXLFFBQVosRUFBWjtBQUFtQyxrREFBQywwQkFBRCxJQUFrQixNQUFNLEVBQXhCO0FBQW5DO0FBVFIsYUFESjtBQWNIOzs7O0VBN0JlRyxnQkFBTUMsUzs7QUFnQzFCLElBQU1DLGtCQUFrQixTQUFsQkEsZUFBa0IsQ0FBQ0MsS0FBRDtBQUFBLFdBQVk7QUFDaENQLHlCQUFpQk8sTUFBTUMsSUFBTixDQUFXUixlQURJO0FBRWhDRCxzQkFBY1EsTUFBTUMsSUFBTixDQUFXQztBQUZPLEtBQVo7QUFBQSxDQUF4Qjs7QUFLQSxJQUFNQyxxQkFBcUIsU0FBckJBLGtCQUFxQixDQUFDQyxRQUFEO0FBQUEsV0FBYywrQkFBbUJDLG9CQUFuQixFQUFtQ0QsUUFBbkMsQ0FBZDtBQUFBLENBQTNCOztrQkFFZSw2QkFBVyx5QkFBUUwsZUFBUixFQUF5Qkksa0JBQXpCLEVBQTZDaEIsS0FBN0MsQ0FBWCxDIiwiZmlsZSI6IkxvZ2luLmpzIiwic291cmNlUm9vdCI6Ii9zcmMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IGF4aW9zIGZyb20gJ2F4aW9zJztcbmltcG9ydCB7IGJpbmRBY3Rpb25DcmVhdG9ycyB9IGZyb20gJ3JlZHV4JztcbmltcG9ydCB7IGNvbm5lY3QgfSBmcm9tICdyZWFjdC1yZWR1eCc7XG5pbXBvcnQgeyB3aXRoUm91dGVyIH0gZnJvbSAncmVhY3Qtcm91dGVyJ1xuaW1wb3J0IHsgYWN0aW9uQ3JlYXRvcnMgfSBmcm9tICcuLi9hY3Rpb25zL2F1dGgnO1xuaW1wb3J0IENpcmN1bGFyUHJvZ3Jlc3MgZnJvbSAnbWF0ZXJpYWwtdWkvQ2lyY3VsYXJQcm9ncmVzcyc7XG5pbXBvcnQgJy4uL3N0eWxlcy9Hb29nbGVMb2dpbkJ1dHRvbi5jc3MnO1xuXG5jbGFzcyBMb2dpbiBleHRlbmRzIFJlYWN0LkNvbXBvbmVudCB7XG5cbiAgICBjb25zdHJ1Y3Rvcihwcm9wcykge1xuICAgICAgICBzdXBlcihwcm9wcyk7XG5cbiAgICAgICAgdGhpcy5vblJlcXVlc3RMb2dpbiA9IHRoaXMub25SZXF1ZXN0TG9naW4uYmluZCh0aGlzKTtcbiAgICB9XG5cbiAgICBvblJlcXVlc3RMb2dpbigpIHtcbiAgICAgICAgdGhpcy5wcm9wcy5sb2dpblJlcXVlc3QoKTtcbiAgICB9XG5cbiAgICByZW5kZXIoKSB7XG4gICAgICAgIGNvbnN0IHsgZXJyb3JNZXNzYWdlLCByZXF1ZXN0aW5nTG9naW4gfSA9IHRoaXMucHJvcHM7XG5cbiAgICAgICAgcmV0dXJuIChcbiAgICAgICAgICAgIDxkaXY+XG4gICAgICAgICAgICAgICAgPGgxIHN0eWxlPXt7dGV4dEFsaWduOiAnY2VudGVyJ319PkFwcHMgZGUgQm9sc28gLSBDb250ZcO6ZG88L2gxPlxuICAgICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwibG9naW4tYnV0dG9uXCIgb25DbGljaz17dGhpcy5vblJlcXVlc3RMb2dpbn0+PC9kaXY+XG4gICAgICAgICAgICAgICAge1xuICAgICAgICAgICAgICAgICAgICBlcnJvck1lc3NhZ2UgJiYgZXJyb3JNZXNzYWdlLmxlbmd0aCA+IDEgJiZcbiAgICAgICAgICAgICAgICAgICAgPGRpdj48cCBzdHlsZT17e3RleHRBbGlnbjogJ2NlbnRlcicsIGNvbG9yOiAncmVkJ319PnsgZXJyb3JNZXNzYWdlIH08L3A+PC9kaXY+XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgICAgICAgcmVxdWVzdGluZ0xvZ2luICYmXG4gICAgICAgICAgICAgICAgICAgIDxkaXYgc3R5bGU9e3t0ZXh0QWxpZ246ICdjZW50ZXInfX0+PENpcmN1bGFyUHJvZ3Jlc3Mgc2l6ZT17NjB9IC8+PC9kaXY+XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICk7XG4gICAgfVxufVxuXG5jb25zdCBtYXBTdGF0ZVRvUHJvcHMgPSAoc3RhdGUpID0+ICh7XG4gICAgcmVxdWVzdGluZ0xvZ2luOiBzdGF0ZS5hdXRoLnJlcXVlc3RpbmdMb2dpbixcbiAgICBlcnJvck1lc3NhZ2U6IHN0YXRlLmF1dGgubG9naW5FcnJvck1lc3NhZ2Vcbn0pO1xuXG5jb25zdCBtYXBEaXNwYXRjaFRvUHJvcHMgPSAoZGlzcGF0Y2gpID0+IGJpbmRBY3Rpb25DcmVhdG9ycyhhY3Rpb25DcmVhdG9ycywgZGlzcGF0Y2gpO1xuXG5leHBvcnQgZGVmYXVsdCB3aXRoUm91dGVyKGNvbm5lY3QobWFwU3RhdGVUb1Byb3BzLCBtYXBEaXNwYXRjaFRvUHJvcHMpKExvZ2luKSk7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/client/containers/Login.js
// module id = 3238
// module chunks = 0